import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {InoFakturaDocument} from "./InoFakturaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga, tekući račun, datum valute

export const inoFakturaDocumentFields: IntercateKeysMap<InoFakturaDocument, EntityField<InoFakturaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	dueDate: {
		name: "dueDate", dataType: EntityFieldDataType._date, label: "Datum valute",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj tekućeg računa",
		validator: { required: false },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<InoFakturaDocument>> = [
	inoFakturaDocumentFields.indexingNumber,
	inoFakturaDocumentFields.indexingDate,
	inoFakturaDocumentFields.documentNumber,
	inoFakturaDocumentFields.documentDate,
	inoFakturaDocumentFields.assignedTo,
	inoFakturaDocumentFields.clientId,
	inoFakturaDocumentFields.sectorId,
	inoFakturaDocumentFields.tags,
	inoFakturaDocumentFields.description,
	inoFakturaDocumentFields.dueDate,
	inoFakturaDocumentFields.accountNumber,
	inoFakturaDocumentFields.parentId
]

export const inoFakturaDocumentFieldsDescriptor: EntityFieldsDescriptor<InoFakturaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
